/**
 * Clear direct login params from the URL for Japan market
 */
export default function clearDirectLoginParams() {
  const current = new URLSearchParams(window.location.search);
  const next = new URLSearchParams();

  current.forEach((value, key) => {
    if (key === "market" || key === "source") next.append(key, value);
  });

  const search = next.toString();

  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`,
  );
}
